import { IconCheckDefault } from '@iwoca/icons';

import styles from './DocumentRequirementStep.module.css';

type TProps = {
  stepNumber: number;
  title: string;
  isComplete?: boolean;
  isActive?: boolean;
  children: React.ReactNode;
};

const DocumentRequirementStep = ({
  stepNumber,
  title,
  isComplete = false,
  isActive = false,
  children,
}: TProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          {isComplete && (
            <IconCheckDefault
              width={20}
              height={20}
              className={styles.checkIcon}
              data-testid="step-complete-icon"
            />
          )}
          <h3 className={styles.title}>
            <span className={styles.stepNumber}>{stepNumber}.</span> {title}
          </h3>
        </div>
      </div>
      {isActive && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default DocumentRequirementStep;
